// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  background: linear-gradient(90deg, rgb(28, 27, 27) 0%, rgb(26, 23, 23) 100%);
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.2rem;
  padding: 0 20px;
}

.navbar-logo {
  color: #fff;
  cursor: pointer;
  text-decoration: none;
  font-size: 2rem;
}

.navbar-logo img {
  max-height: 60px; /* Passt die maximale Höhe des Logos an */
  max-width: auto;  /* Passt die Breite des Logos automatisch an */
  height: auto;     /* Erhält das Seitenverhältnis des Logos */
  width: auto;      /* Erhält das Seitenverhältnis des Logos */
}

.nav-menu {
  display: flex;
  justify-content: center;
  flex: 1 1;
}

.nav-item {
  display: flex;
  align-items: center;
  height: 80px;
}

.nav-item-logout {
  display: none; /* Standardmäßig ausgeblendet */
}

.nav-links {
  color: white;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 1rem;
}

.nav-icon {
  display: none; /* Icons in the normal view will be hidden */
}

.nav-text {
  display: block; /* Text in the normal view will be visible */
}

.nav-links:hover {
  background-color: gray;
  border-radius: 4px;
  transition: all 0.2s ease-out;
}

.navbar-profile {
  display: flex;
  justify-content: flex-end;
  flex: 1 1;
}

@media screen and (max-width: 960px) {
  .nav-item-logout {
    display: block; /* Nur in der mobilen Ansicht anzeigen */
  }
  .nav-menu {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: #242222;
    display: flex;
    justify-content: space-around;
    align-items: center;
    z-index: 999;
  }

  .navbar-logo img {
    max-height: 50px; /* Kleinere Größe für mobile Geräte */
  }

  .nav-item {
    height: auto;
  }

  .nav-links {
    padding: 0;
  }

  .nav-icon {
    display: block; /* Icons will be visible in the mobile view */
  }

  .nav-text {
    display: block; /* Text will be visible in the mobile view */
  }

  .nav-links:hover .nav-text {
    display: block;
  }

  .navbar-profile {
    display: none; /* Profile will be hidden in the mobile view */
  }
}

@media screen and (min-width: 1024px) {
  .nav-text-l {
    display: none;
  }
  
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;EACE,4EAA4E;EAC5E,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB,EAAE,yCAAyC;EAC3D,eAAe,GAAG,8CAA8C;EAChE,YAAY,MAAM,0CAA0C;EAC5D,WAAW,OAAO,0CAA0C;AAC9D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa,EAAE,+BAA+B;AAChD;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa,EAAE,4CAA4C;AAC7D;;AAEA;EACE,cAAc,EAAE,4CAA4C;AAC9D;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAO;AACT;;AAEA;EACE;IACE,cAAc,EAAE,wCAAwC;EAC1D;EACA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,gBAAgB,EAAE,qCAAqC;EACzD;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc,EAAE,6CAA6C;EAC/D;;EAEA;IACE,cAAc,EAAE,4CAA4C;EAC9D;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa,EAAE,8CAA8C;EAC/D;AACF;;AAEA;EACE;IACE,aAAa;EACf;;AAEF","sourcesContent":[".navbar {\r\n  background: linear-gradient(90deg, rgb(28, 27, 27) 0%, rgb(26, 23, 23) 100%);\r\n  height: 80px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  font-size: 1.2rem;\r\n  padding: 0 20px;\r\n}\r\n\r\n.navbar-logo {\r\n  color: #fff;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  font-size: 2rem;\r\n}\r\n\r\n.navbar-logo img {\r\n  max-height: 60px; /* Passt die maximale Höhe des Logos an */\r\n  max-width: auto;  /* Passt die Breite des Logos automatisch an */\r\n  height: auto;     /* Erhält das Seitenverhältnis des Logos */\r\n  width: auto;      /* Erhält das Seitenverhältnis des Logos */\r\n}\r\n\r\n.nav-menu {\r\n  display: flex;\r\n  justify-content: center;\r\n  flex: 1;\r\n}\r\n\r\n.nav-item {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 80px;\r\n}\r\n\r\n.nav-item-logout {\r\n  display: none; /* Standardmäßig ausgeblendet */\r\n}\r\n\r\n.nav-links {\r\n  color: white;\r\n  text-decoration: none;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 0.5rem 1rem;\r\n}\r\n\r\n.nav-icon {\r\n  display: none; /* Icons in the normal view will be hidden */\r\n}\r\n\r\n.nav-text {\r\n  display: block; /* Text in the normal view will be visible */\r\n}\r\n\r\n.nav-links:hover {\r\n  background-color: gray;\r\n  border-radius: 4px;\r\n  transition: all 0.2s ease-out;\r\n}\r\n\r\n.navbar-profile {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  flex: 1;\r\n}\r\n\r\n@media screen and (max-width: 960px) {\r\n  .nav-item-logout {\r\n    display: block; /* Nur in der mobilen Ansicht anzeigen */\r\n  }\r\n  .nav-menu {\r\n    position: fixed;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 60px;\r\n    background: #242222;\r\n    display: flex;\r\n    justify-content: space-around;\r\n    align-items: center;\r\n    z-index: 999;\r\n  }\r\n\r\n  .navbar-logo img {\r\n    max-height: 50px; /* Kleinere Größe für mobile Geräte */\r\n  }\r\n\r\n  .nav-item {\r\n    height: auto;\r\n  }\r\n\r\n  .nav-links {\r\n    padding: 0;\r\n  }\r\n\r\n  .nav-icon {\r\n    display: block; /* Icons will be visible in the mobile view */\r\n  }\r\n\r\n  .nav-text {\r\n    display: block; /* Text will be visible in the mobile view */\r\n  }\r\n\r\n  .nav-links:hover .nav-text {\r\n    display: block;\r\n  }\r\n\r\n  .navbar-profile {\r\n    display: none; /* Profile will be hidden in the mobile view */\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n  .nav-text-l {\r\n    display: none;\r\n  }\r\n  \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
